import { render, staticRenderFns } from "./channelRealData.vue?vue&type=template&id=336f9706"
import script from "./channelRealData.vue?vue&type=script&lang=js"
export * from "./channelRealData.vue?vue&type=script&lang=js"
import style0 from "./channelRealData.vue?vue&type=style&index=0&id=336f9706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports